import { default as Checkbox } from './Checkbox';
import { default as ControlLabel } from './ControlLabel';
import { default as Form } from './Form';
import { default as FormControl } from './FormControl';
import { default as FormGroup } from './FormGroup';
import { default as HelpBlock } from './HelpBlock';
import { default as InputGroup } from './InputGroup';
import { default as Radio } from './Radio';

Form.Checkbox = Checkbox;
Form.ControlLabel = ControlLabel;
Form.FormControl = FormControl;
Form.FormGroup = FormGroup;
Form.HelpBlock = HelpBlock;
Form.InputGroup = InputGroup;
Form.Radio = Radio;

export { Checkbox, ControlLabel, Form, FormControl, FormGroup, HelpBlock, InputGroup, Radio };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Form/index.js
// module id = 149
// module chunks = 0